var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"-mx-3 my-4 border-gray-300"})
}
var staticRenderFns = []

export { render, staticRenderFns }